import React from 'react';
import { compose } from 'redux';

import withToggle from 'dpl/decorators/withToggle';
import BreederProfileHelpBox from 'dpl/components/BreederProfile/Index/BreederProfileHelpBox';

function BreederProfileHelpBoxContainer(props) {
  return <BreederProfileHelpBox {...props} />;
}

export default compose(withToggle({ propName: 'modalIsOpen' }))(
  BreederProfileHelpBoxContainer
);
